import React from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import VLogo from "../assets/logo/v.jpeg";
import logo4 from "../assets/logo4.jpeg";
import logo1 from "../assets/logo1.jpg";
import logo2 from "../assets/logo2.jpeg";
import logo3 from "../assets/logo3.jpeg";
import HGNlogo from "../assets/logo/HGN.png";
import flogo from "../assets/logo/f.jpeg";
import MsLogo from "../assets/logo/Ms.jpeg";


const Partenaires = () => {
  const partenaires = {
    hopitaux: [
      {
        nom: "Hopital Mohamed V",
        ville: "Meknes",
        pays: "Maroc",
        logo: VLogo, // À remplacer par le vrai logo
        description:
          "Premier centre hospitalier de meknes, partenaire historique pour la formation et la télémédecine.",
      },
      {
        nom: "Hopital Général de Ngoyo",
        ville: "Pointe-Noire",
        pays: "Congo-Brazzaville",
        logo: HGNlogo, // À remplacer par le vrai logo
        description:
          "Centre médical de pointe spécialisé dans la chirurgie mini-invasive et la téléconsultation.",
      },
    ],
    universites: [
      {
        nom: "EEMSI",
        ville: "MEKNES",
        pays: "MAROC",
        logo: logo2,
        description:
          "Collaboration académique pour la recherche en e-santé et la formation des professionnels de santé.",
      },
      {
        nom: "EEMCI",
        ville: "MEKNES",
        pays: "MAROC",
        logo: logo1, // À remplacer par le vrai logo
        description:
          "Partenariat pour le développement de solutions innovantes en santé numérique.",
      },
    ],
    tech: [
      {
        nom: "WebConsulting",
        type: "Technologie",
        logo: logo4,
        description:
          "Partenaire technologique pour l'infrastructure réseau et la connectivité mobile.",
      },
      {
        nom: "Microsoft Africa",
        type: "Cloud & IA",
        logo: MsLogo, // À remplacer par le vrai logo
        description:
          "Collaboration pour le développement d'solutions d'IA en santé et l'hébergement cloud.",
      },
    ],
    organisations: [
      {
        nom: "association des secouriste sans frontières",
        type: "Organisation Nationale",
        logo: logo3,
        description:
          "Partenariat pour l'amélioration de l'accès aux soins.",
      },
      {
        nom: "Fondation Ferdy",
        type: "Organisation philanthropique",
        logo: flogo, // À remplacer par le vrai logo
        description:
          "Soutien pour l'expansion de nos services dans les zones rurales.",
      },
    ],
  };

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Nos Partenaires
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ensemble, nous transformons l'accès aux soins de santé en Afrique
          </p>
        </motion.div>

        {/* Hôpitaux Partenaires */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Hôpitaux Partenaires
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {partenaires.hopitaux.map((hopital) => (
              <motion.div
                key={hopital.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200">
                  {hopital.logo ? (
                    <img
                      src={hopital.logo}
                      alt={`Logo ${hopital.nom}`}
                      className="object-contain h-48 w-full"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-48 bg-blue-50">
                      <span className="text-4xl">🏥</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {hopital.nom}
                  </h3>
                  <p className="text-blue-600 mb-4">
                    {hopital.ville}, {hopital.pays}
                  </p>
                  <p className="text-gray-600">{hopital.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Universités Partenaires */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Partenaires Académiques
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {partenaires.universites.map((universite) => (
              <motion.div
                key={universite.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200">
                  {universite.logo ? (
                    <img
                      src={universite.logo}
                      alt={`Logo ${universite.nom}`}
                      className="object-contain h-48 w-full"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-48 bg-blue-50">
                      <span className="text-4xl">🎓</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {universite.nom}
                  </h3>
                  <p className="text-blue-600 mb-4">
                    {universite.ville}, {universite.pays}
                  </p>
                  <p className="text-gray-600">{universite.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Partenaires Technologiques */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Partenaires Technologiques
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {partenaires.tech.map((tech) => (
              <motion.div
                key={tech.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200">
                  {tech.logo ? (
                    <img
                      src={tech.logo}
                      alt={`Logo ${tech.nom}`}
                      className="object-contain h-48 w-full"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-48 bg-blue-50">
                      <span className="text-4xl">💻</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {tech.nom}
                  </h3>
                  <p className="text-blue-600 mb-4">{tech.type}</p>
                  <p className="text-gray-600">{tech.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Organisations Internationales */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Organisations Internationales
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {partenaires.organisations.map((org) => (
              <motion.div
                key={org.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200">
                  {org.logo ? (
                    <img
                      src={org.logo}
                      alt={`Logo ${org.nom}`}
                      className="object-contain h-48 w-full"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-48 bg-blue-50">
                      <span className="text-4xl">🌍</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {org.nom}
                  </h3>
                  <p className="text-blue-600 mb-4">{org.type}</p>
                  <p className="text-gray-600">{org.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Call to Action */}
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-blue-50 rounded-lg p-8 text-center"
        >
          <h2 className="text-2xl font-semibold text-blue-900 mb-4">
            Devenez Partenaire
          </h2>
          <p className="text-blue-700 mb-6 max-w-2xl mx-auto">
            Vous souhaitez contribuer à la transformation de la santé en Afrique ?
            Rejoignez notre réseau de partenaires.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.location.href = "/contact"}
            className="bg-blue-600 text-white px-8 py-3 rounded-full font-medium hover:bg-blue-700 transition-colors"
          >
            Contactez-nous
          </motion.button>
        </motion.section>
      </div>
    </div>
  );
};

export default Partenaires;